const initialState = () => {
  return {
    loadingState: false,
    showConfigurationSteps: false,
    configurationSteps: {},
    expiviViewerData: [],
    expiviThumbnail: null,
    debugExpiviData: false,
  }
};

const state = initialState();

const mutations = {
  SET_CONFIGURATION_STEPS(state, payload) {
    state.configurationSteps = payload;
  },
  UPDATE_LOADING_STATE(state, payload) {
    state.loadingState = payload;
  },
  SET_SHOW_CONFIGURATION_STEPS(state, payload) {
    state.showConfigurationSteps = payload;
  },
  SET_EXPIVI_VIEWER_DATA(state, payload) {
    state.expiviViewerData = payload;
  },
  SET_EXPIVI_THUMBNAIL(state, payload) {
    state.expiviThumbnail = payload;
  }
};

const actions = {
  async getConfigurationData({commit, dispatch}, callbackUrl) {
    commit('UPDATE_LOADING_STATE', true);
    try {
      await this.$solarClient.get(callbackUrl).then(({data}) => {
        commit('SET_CONFIGURATION_STEPS', data);
        if (!data['completed'] && !data.error) {
          commit('SET_SHOW_CONFIGURATION_STEPS', true);
        }

        if (!data.error) {
          dispatch('setExpiviViewerData', data || {});
        }
      });
    } catch (e) {
      console.error(e);
    } finally {
      commit('UPDATE_LOADING_STATE', false);
    }
  },
  setExpiviViewerData({state, commit}, payload) {
    const expiviStepData = payload.steps.map(step => {
      let selectedValue = null;
      if (step.value !== '') {
        selectedValue = step.possibleValues.find(value => value.key === step.value).attributes.EanCode;
      }

      return [
        step.attributes.EanCode,
        selectedValue,
      ].filter(Boolean);
    });

    if (state.debugExpiviData) {
      console.debug('Expivi Viewer Data:', expiviStepData);
    }

    commit('SET_EXPIVI_VIEWER_DATA', expiviStepData);
  },
  setExpiviThumbnail({commit}, thumbnailUrl) {
    commit('SET_EXPIVI_THUMBNAIL', thumbnailUrl);
  },
  createInitialConfigurationSteps({commit, dispatch, getters}, productSku) {
    const callbackUrl = `/api/logictrade/${productSku}`;
    dispatch('getConfigurationData', callbackUrl);
  }
};

const getters = {
  getLoadingState: state => {
    return state.loadingState;
  },
  getConfigurationSteps: state => {
    return state.configurationSteps;
  },
  getConfiguratorState: state => {
    return state.configurationSteps['completed'];
  },
  getConfiguratorGuid: state => {
    return state.configurationSteps['configurationGuid'] || '';
  },
  getShowConfigurationSteps: state => {
    return state.showConfigurationSteps;
  },
  getConfigurationPrice: state => {
    return {
      priceInclTax: state.configurationSteps.hasOwnProperty('summary') ? state.configurationSteps['summary']['Price'] : 0,
      totalPriceInclTax: state.configurationSteps.hasOwnProperty('summary') ? state.configurationSteps['summary']['ActionPrice'] : 0
    };
  },
  getExpiviViewerData: state => {
    return state.expiviViewerData;
  },
  getExpiviThumbnail: state => {
    return state.expiviThumbnail;
  }
};

const CatalogConfigurator = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};

export default CatalogConfigurator;
